import React from 'react'
import { ContainerProps } from '@/types'
import styles from './Container.module.css'

const Container: React.FC<ContainerProps> = ({ 
  children, 
  fluid = false, 
  className = '',
  as: Component = 'div'
}) => {
  const containerClass = fluid 
    ? `${styles.containerFluid} ${className}`.trim()
    : `${styles.container} ${className}`.trim()

  return (
    <Component className={containerClass}>
      {children}
    </Component>
  )
}

export default Container
